import { forwardRef, InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { cln } from '../lib/utils';

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({ label, error, className, ...props }, ref) => {
    const { t } = useTranslation();
    const id = crypto.randomUUID();
    return (
      <span className={cln('textarea', className)}>
        <label htmlFor={id}>{t(label)}</label>
        <textarea {...props} ref={ref} />
        {error && <span className="text-label text-danger-500">{t(error)}</span>}
      </span>
    );
  },
);

TextArea.displayName = 'TextArea';
